module.exports = __webpack_public_path__ + "fonts/font.d9da5b0.woff";